import { useQuery } from "@tanstack/react-query";

import { useCompany } from "#modules/company/view/useCompany";
import { customSurfaceTreatmentsQuery } from "#modules/companySettings/infra/customSurfaceTreatments.query";

export const useCustomSurfaceTreatments = () => {
  const { company } = useCompany();
  const { data, ...rest } = useQuery({
    ...customSurfaceTreatmentsQuery(company?.id),
  });

  return { customSurfaceTreatments: data ?? [], ...rest };
};
